export default __webpack_public_path__ + "static/media/Singer Sewing Machine.be5dcee7.jpg";